/* Little Toys v5 · "Vitrina mágica" — capa de movimiento.
   Todo el contenido parte visible en CSS; aquí solo se anima si hay movimiento permitido. */
(function () {
  const root = document.documentElement;
  const motionOK = matchMedia('(prefers-reduced-motion: no-preference)').matches;
  const fine = matchMedia('(hover: hover) and (pointer: fine)').matches;
  if (motionOK) root.classList.add('lt5-js');

  /* ---------- Hero: órbita 3D ---------- */
  function hero(stage) {
    if (!stage || stage.dataset.lt5Done || !motionOK) return;
    stage.dataset.lt5Done = '1';
    const toys = [...stage.querySelectorAll('[data-lt5-toy]')];
    if (!toys.length) return;
    const hero = stage.closest('.lt5-hero');
    const n = toys.length, TAU = Math.PI * 2;
    let W = 0, H = 0;
    const measure = () => { const r = stage.getBoundingClientRect(); W = r.width; H = r.height; };
    measure();
    new ResizeObserver(measure).observe(stage);

    let seen = false;
    try { seen = sessionStorage.getItem('lt5-hero') === '1'; sessionStorage.setItem('lt5-hero', '1'); } catch (e) {}

    const st = { spin: -Math.PI / 2, speed: 0.16, target: 0.16, intro: seen ? 1 : 0, spread: 1, tilt: 0, tiltT: 0, fade: 1 };
    let paused = false, hovering = false, visible = true;

    stage.classList.add('lt5-live');
    toys.forEach(t => { t.style.left = '0'; t.style.top = '0'; t.style.translate = 'none'; });

    function frame(time, delta) {
      if (!visible || !W) return;
      const dt = Math.min(delta, 50) / 1000;
      st.speed += ((paused || hovering ? 0 : st.target) - st.speed) * Math.min(1, dt * 4);
      st.spin += st.speed * dt;
      st.tilt += (st.tiltT - st.tilt) * Math.min(1, dt * 5);
      const cx = W * 0.5, cy = H * 0.54;
      const rx = W * 0.40 * st.intro * st.spread, ry = H * (0.19 + st.tilt * 0.08) * st.intro * st.spread;
      for (let i = 0; i < n; i++) {
        const a = st.spin + (i / n) * TAU;
        const d = (Math.sin(a) + 1) / 2; // 0 atrás · 1 adelante
        const s = (0.78 + 0.5 * d) * (0.3 + 0.7 * st.intro);
        const x = cx + Math.cos(a) * rx, y = cy + Math.sin(a) * ry - (1 - d) * H * 0.06;
        const t = toys[i];
        t.style.transform = `translate3d(${x.toFixed(1)}px,${y.toFixed(1)}px,0) translate(-50%,-50%) scale(${s.toFixed(3)})`;
        t.style.zIndex = String(10 + Math.round(d * 100));
        t.style.opacity = String(((0.5 + 0.5 * d) * st.fade).toFixed(3));
      }
    }

    const useGsap = !!window.gsap;
    if (useGsap) {
      gsap.ticker.add(frame);
      if (!seen) {
        gsap.to(st, { intro: 1, duration: 1.4, ease: 'back.out(1.5)', delay: 0.15 });
        gsap.from(hero.querySelectorAll('h1 .m'), { yPercent: 115, duration: 0.9, ease: 'power4.out', stagger: 0.09 });
        gsap.from(hero.querySelectorAll('.lt5-eyebrow, .lt5-hero__sub, .lt5-hero__note, .lt5-hero__ctas, .lt5-proof'), { opacity: 0, y: 18, duration: 0.7, ease: 'power3.out', stagger: 0.07, delay: 0.35 });
        gsap.from(stage.querySelectorAll('.lt5-core, .lt5-ring'), { scale: 0.4, opacity: 0, duration: 1.1, ease: 'expo.out', stagger: 0.08 });
        gsap.from(stage.querySelector('.lt5-badge'), { scale: 0, rotation: -60, duration: 0.7, ease: 'back.out(2.2)', delay: 1.1 });
      }
      if (window.ScrollTrigger) {
        gsap.registerPlugin(ScrollTrigger);
        const sc = scroller();
        if (sc !== window) ScrollTrigger.defaults({ scroller: sc });
        ScrollTrigger.create({ trigger: hero, start: 'top top', end: 'bottom top', scrub: 0.6,
          onUpdate: self => { st.spread = 1 + self.progress * 0.55; st.fade = 1 - self.progress * 0.65; } });
      }
    } else {
      st.intro = 1;
      let last = performance.now();
      const loop = now => { frame(now, now - last); last = now; requestAnimationFrame(loop); };
      requestAnimationFrame(loop);
    }

    new IntersectionObserver(es => { visible = es[0].isIntersecting; }, { rootMargin: '80px' }).observe(stage);

    toys.forEach(t => {
      t.addEventListener('pointerenter', () => { hovering = true; });
      t.addEventListener('pointerleave', () => { hovering = false; });
      t.addEventListener('focus', () => { hovering = true; });
      t.addEventListener('blur', () => { hovering = false; });
    });

    if (fine) {
      stage.addEventListener('pointermove', e => {
        const r = stage.getBoundingClientRect();
        const dx = (e.clientX - r.left) / r.width - 0.5, dy = (e.clientY - r.top) / r.height - 0.5;
        st.target = 0.16 + dx * 0.5;
        st.tiltT = dy * 2;
      });
      stage.addEventListener('pointerleave', () => { st.target = 0.16; st.tiltT = 0; });
    }

    /* Botón de pausa (animación continua de más de 5 s) */
    const btn = document.createElement('button');
    btn.type = 'button'; btn.className = 'lt5-pause';
    btn.setAttribute('aria-pressed', 'false');
    btn.innerHTML = '<span class="lt5-sr">Pausar animación de juguetes</span><svg width="14" height="14" viewBox="0 0 14 14" aria-hidden="true"><rect x="2" y="1" width="3.5" height="12" rx="1" fill="currentColor"/><rect x="8.5" y="1" width="3.5" height="12" rx="1" fill="currentColor"/></svg>';
    btn.addEventListener('click', () => {
      paused = !paused;
      btn.setAttribute('aria-pressed', String(paused));
      btn.querySelector('.lt5-sr').textContent = paused ? 'Reanudar animación de juguetes' : 'Pausar animación de juguetes';
      btn.querySelector('svg').innerHTML = paused ? '<path d="M3 1.5v11l9-5.5z" fill="currentColor"/>' : '<rect x="2" y="1" width="3.5" height="12" rx="1" fill="currentColor"/><rect x="8.5" y="1" width="3.5" height="12" rx="1" fill="currentColor"/>';
    });
    stage.appendChild(btn);
  }

  /* ---------- Botones magnéticos ---------- */
  function magnets() {
    if (!motionOK || !fine) return;
    document.querySelectorAll('[data-lt5-magnet]:not([data-lt5-m])').forEach(b => {
      b.dataset.lt5M = '1';
      b.addEventListener('pointermove', e => {
        const r = b.getBoundingClientRect();
        b.style.transform = `translate(${((e.clientX - r.left) / r.width - 0.5) * 10}px,${((e.clientY - r.top) / r.height - 0.5) * 8}px)`;
      });
      b.addEventListener('pointerleave', () => { b.style.transform = ''; });
    });
  }

  /* ---------- Tarjetas de producto con inclinación 3D ---------- */
  function tilt() {
    if (!motionOK || !fine || document.body.dataset.lt5Tilt) return;
    document.body.dataset.lt5Tilt = '1';
    let cur = null, raf = 0, ev = null;
    const SEL = 'main product-card .product-card__content, .lt5-franq a, .lt5-col__item';
    document.addEventListener('pointermove', e => {
      const el = e.target.closest && e.target.closest(SEL);
      if (el !== cur) { if (cur) { cur.style.transform = ''; } cur = el; if (cur) cur.classList.add('lt5-tilt'); }
      if (!cur) return;
      ev = e;
      if (!raf) raf = requestAnimationFrame(() => {
        raf = 0; if (!cur || !ev) return;
        const r = cur.getBoundingClientRect();
        const rx = ((ev.clientY - r.top) / r.height - 0.5) * -7, ry = ((ev.clientX - r.left) / r.width - 0.5) * 9;
        cur.style.transform = `perspective(800px) rotateX(${rx.toFixed(2)}deg) rotateY(${ry.toFixed(2)}deg) translateY(-4px)`;
      });
    }, { passive: true });
    document.addEventListener('pointerleave', () => { if (cur) cur.style.transform = ''; cur = null; });
  }

  /* ---------- Foco de luz en coleccionistas ---------- */
  function spotlight() {
    if (!fine) return;
    document.querySelectorAll('.lt-collect:not([data-lt5-s]), [data-lt5-spot]:not([data-lt5-s])').forEach(c => {
      c.dataset.lt5S = '1';
      c.addEventListener('pointermove', e => {
        const r = c.getBoundingClientRect();
        c.style.setProperty('--mx', (e.clientX - r.left) + 'px');
        c.style.setProperty('--my', (e.clientY - r.top) + 'px');
      }, { passive: true });
    });
  }

  /* ---------- Carro: rebote al agregar ---------- */
  function cartBump() {
    if (!motionOK || document.body.dataset.lt5Cart) return;
    document.body.dataset.lt5Cart = '1';
    document.addEventListener('cart:update', () => {
      const icon = document.querySelector('cart-icon, .header-actions__cart-icon, a[href$="/cart"]');
      if (!icon) return;
      icon.classList.remove('lt5-bump'); void icon.offsetWidth; icon.classList.add('lt5-bump');
    });
  }

  /* ---------- Reel "Lo más top" ---------- */
  function reel() {
    document.querySelectorAll('[data-lt5-reel]:not([data-lt5-r])').forEach(box => {
      box.dataset.lt5R = '1';
      const v = box.querySelector('video'), b = box.querySelector('.lt5-reel__btn');
      if (!v) return;
      let user = false;
      const setBtn = () => {
        if (!b) return;
        const playing = !v.paused;
        b.setAttribute('aria-label', playing ? 'Pausar video' : 'Reproducir video');
        b.innerHTML = playing ? '<svg width="16" height="16" viewBox="0 0 14 14" aria-hidden="true"><rect x="2" y="1" width="3.5" height="12" rx="1" fill="currentColor"/><rect x="8.5" y="1" width="3.5" height="12" rx="1" fill="currentColor"/></svg>' : '<svg width="16" height="16" viewBox="0 0 14 14" aria-hidden="true"><path d="M3 1.5v11l9-5.5z" fill="currentColor"/></svg>';
      };
      v.addEventListener('play', setBtn); v.addEventListener('pause', setBtn);
      if (b) b.addEventListener('click', () => { user = true; v.paused ? v.play() : v.pause(); });
      if (!motionOK) { v.removeAttribute('autoplay'); v.pause(); setBtn(); return; }
      new IntersectionObserver(es => {
        if (user) return;
        if (es[0].isIntersecting) {
          if (!v.src && v.dataset.src) { v.querySelectorAll('source[data-src]').forEach(s => { s.src = s.dataset.src; }); v.load(); }
          v.play().catch(() => {});
        } else v.pause();
      }, { rootMargin: '200px 0px' }).observe(box);
      setBtn();
    });
  }

  /* El tema (Horizon) hace scroll dentro de .page-wrapper, no en la ventana */
  function scroller() {
    const pw = document.querySelector('.page-wrapper');
    if (pw && /(auto|scroll)/.test(getComputedStyle(pw).overflowY) && pw.scrollHeight > pw.clientHeight + 4) return pw;
    return window;
  }

  /* ---------- Barra de progreso de lectura ---------- */
  function progress() {
    if (!motionOK || document.querySelector('.lt5-progress')) return;
    const bar = document.createElement('div');
    bar.className = 'lt5-progress'; bar.setAttribute('aria-hidden', 'true');
    document.body.appendChild(bar);
    const sc = scroller(), el = sc === window ? document.documentElement : sc;
    let raf = 0;
    const upd = () => { raf = 0; const max = el.scrollHeight - el.clientHeight; bar.style.setProperty('--p', max > 0 ? (el.scrollTop / max).toFixed(4) : 0); };
    (sc === window ? window : sc).addEventListener('scroll', () => { if (!raf) raf = requestAnimationFrame(upd); }, { passive: true });
    upd();
  }

  /* ---------- Entrada escalonada de tarjetas ---------- */
  function stagger() {
    if (!motionOK || !('IntersectionObserver' in window)) return;
    const groups = [
      ['[id$="__lt_top"], [id$="__lt_mesa"], [id$="__lt_new"], [id$="__lt_ofertas"]', '.resource-list__slide'],
      ['[id$="__lt_edades"]', '.lt-ages > li'],
      ['[id$="__lt_cats"]', '.lt-cats > li'],
      ['[id$="__lt_collect"]', '.lt5-col__item'],
      ['[id$="__lt_ig"]', '.lt-ig__grid > li'],
      ['[id$="__lt_testi"]', '.lt-testi__card'],
      ['[id$="__lt_trust"]', '.lt-trust > div, .lt-store'],
      ['#lt5-top', '.lt5-franq > li']
    ];
    const io = new IntersectionObserver(es => es.forEach(en => {
      if (!en.isIntersecting) return;
      en.target.querySelectorAll('.lt5-rv').forEach(el => el.classList.add('lt5-in'));
      io.unobserve(en.target);
    }), { rootMargin: '0px 0px -10% 0px' });
    groups.forEach(([sec, item]) => document.querySelectorAll(sec).forEach(s => {
      if (s.dataset.lt5St) return; s.dataset.lt5St = '1';
      const r = s.getBoundingClientRect();
      if (r.top < innerHeight * 0.9) return; // ya visible al cargar: no se esconde
      let i = 0;
      s.querySelectorAll(item).forEach(el => { if (i < 10) { el.style.setProperty('--d', (i * 0.06).toFixed(2) + 's'); el.classList.add('lt5-rv'); i++; } });
      io.observe(s);
    }));
  }

  /* ---------- Contador del puntaje de Google ---------- */
  function counters() {
    if (!motionOK) return;
    document.querySelectorAll('.lt-testi__score b:not([data-lt5-c])').forEach(b => {
      b.dataset.lt5C = '1';
      const target = parseFloat(b.textContent.replace(',', '.'));
      if (!target) return;
      const io = new IntersectionObserver(es => {
        if (!es[0].isIntersecting) return; io.disconnect();
        const t0 = performance.now();
        const step = now => { const k = Math.min(1, (now - t0) / 1100), e = 1 - Math.pow(1 - k, 3);
          b.textContent = (target * e).toFixed(1).replace('.', ','); if (k < 1) requestAnimationFrame(step); };
        requestAnimationFrame(step);
      });
      io.observe(b);
    });
  }

  function init() {
    document.querySelectorAll('[data-lt5-stage]').forEach(hero);
    magnets(); tilt(); spotlight(); cartBump(); reel(); progress(); stagger(); counters();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  window.addEventListener('load', () => document.querySelectorAll('[data-lt5-stage]').forEach(hero));
  document.addEventListener('shopify:section:load', init);
})();
